import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '@spartacus/asm/root';
import { CmsService, Product, WindowRef } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { CookieService } from 'ngx-cookie';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-cookie-product-capture',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CookieProductCaptureComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  productCode: string;
  currentUID: string;
  asmEnabled = this.winRef.localStorage.getItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  cookieSubscribption$: Subscription;
  recentlyViewCookie$: Subscription;

  // Sample:
  asmUserId: string;
  currentDealerCookieValue: any;
  currentSalesRepCookieValue: any;
  recentlyViewedCookieKey: string;
  constructor(
    protected cookieService: CookieService,
    private currentProductService: CurrentProductService,
    private cd: ChangeDetectorRef,
    protected cms: CmsService,
    private storageService: StorageService,
    private winRef: WindowRef
  ) {}

  product$: Observable<Product> = this.currentProductService.getProduct();

  ngOnInit() {
    this.subscription = this.currentProductService
      .getProduct()
      .pipe(filter(Boolean))
      .subscribe((product: Product) => {
        this.productCode = product.code;
        this.setProductToCookie(this.productCode);
        this.cd.markForCheck();
      });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.recentlyViewCookie$) {
      this.recentlyViewCookie$.unsubscribe();
    }
  }

  setProductToCookie(code: string) {
    this.currentUID = this.storageService.getSessionStorageItem('recentlyViewedCookieKey');
    const recentlyViewedCookieName = this.currentUID;
    if (!this.getCookie(recentlyViewedCookieName)) {
      this.cookieService.put(recentlyViewedCookieName, code);
    } else {
      if (!this.getCookie(recentlyViewedCookieName).includes(code)) {
        this.cookieService.put(recentlyViewedCookieName, `${code} ${this.getCookie(recentlyViewedCookieName)}`);
      } else {
        this.cms.getCurrentPage().subscribe((page) => {
          if (page && page.template === 'ProductDetailsPageTemplate') {
            const recentlyViewedProduct = this.getCookie(recentlyViewedCookieName);
            const result = recentlyViewedProduct
              .trim()
              .split(' ')
              .filter((res) => res.toString() !== code.toString());
            if (result) {
              this.cookieService.put(recentlyViewedCookieName, `${code} ${result.toString().replace(/,/g, ' ')}`);
            }
          }
        });
      }
    }
  }

  getCookie(key: string) {
    return this.cookieService.get(key);
  }
}
